import { Injectable } from '@angular/core';
import {
  CHANNEL_DEFAULTS,
  DISPLAY_TYPE_CHANNELS,
  DISPLAY_TYPE_INDEX_LIMIT,
  SELECTED_DISPLAY_TYPE_TEXT
} from '../components/node-delegator/nodes/templates/display-type-dialog/displayTypeUtils';
import values from 'lodash/values';
import { MatDialog } from '@angular/material/dialog';
import { DisplayTypeDialogComponent } from '../components/node-delegator/nodes/templates/display-type-dialog/display-type-dialog.component';

@Injectable()
export class DisplayTypeService {
  supportedRange: string = DISPLAY_TYPE_INDEX_LIMIT[8]['AUTO'].range;
  displayName: string = '';
  currentIndex: number;
  channelDisplayType: string = '';
  toolTipText: string = '';
  channelId: number;
  currentLogicOption: number = Number.MAX_SAFE_INTEGER;

  constructor(public dialog: MatDialog) { }

  getChannelDisplayType(channelDisplayType: string): string {
    return channelDisplayType.charAt(0).toUpperCase() + channelDisplayType.slice(1);
  }

  checkOptionsMaxLength(channelDisplayType: string, selectedChannel?: number): number {
    const channelId = selectedChannel ? selectedChannel : 8;
    const displayType = channelDisplayType ? channelDisplayType : CHANNEL_DEFAULTS[channelId];
    this.supportedRange = DISPLAY_TYPE_INDEX_LIMIT[channelId][displayType].range;
    this.displayName = DISPLAY_TYPE_INDEX_LIMIT[channelId][displayType].name;

    const maxIndex = DISPLAY_TYPE_INDEX_LIMIT[channelId][displayType].max;
    return (maxIndex > 0) ? maxIndex : null;
  }

  checkIsOptionInvalid(optionLength, channelDisplayType: string, selectedChannel?: number): boolean {
    const maxIndex = this.checkOptionsMaxLength(channelDisplayType, selectedChannel);
    if (maxIndex) {
      return optionLength > maxIndex;
    }
    return false;
  }

  checkOptionsMaxLengthInvalid(options, channelDisplayType: string, selectedChannel?: number): boolean {
    const optionsMaxLength = this.checkOptionsMaxLength(channelDisplayType.toUpperCase(), selectedChannel);
    if (options && optionsMaxLength) {
      const optionsArr = values(options.value);
      return optionsArr.length + 1 > optionsMaxLength;
    }
    return false;
  }

  buildMessage(hasCountWarning?: boolean): string {
      const countWarning = `You currently have ${ this.currentIndex } logic options. `
      return `${hasCountWarning ? countWarning : ""}${ this.displayName } can only support 
        ${ this.supportedRange } options. Additional options will remain but will not be displayed.`;
  }

  buildToolTipText(selectedChannel?: number): string {
    return `Will not display on ${ DISPLAY_TYPE_CHANNELS[selectedChannel] }`;
  }

  getLogicWarning(index: number, values) {
    this.currentLogicOption = Number.MAX_SAFE_INTEGER;
    let data: { name: string, channel: number };
    data = { name:'', channel: 0 };
    for(const channelId in values) {
      const displayType = values[channelId];
      const maxLogicOptions = DISPLAY_TYPE_INDEX_LIMIT[channelId][displayType.toUpperCase()].max;
      if (this.currentLogicOption >= maxLogicOptions && maxLogicOptions > 0) {
        this.currentLogicOption = maxLogicOptions;
        data = {
          name: displayType,
          channel: +channelId
        };
      }
    }
    this.toolTipText = this.buildToolTipText(data.channel);
    let content = { condition: this.checkIsOptionInvalid(index, data.name, data.channel), toolTipText: this.toolTipText, options: this.currentLogicOption.toString()};
    this.currentLogicOption = Number.MAX_SAFE_INTEGER;
    return content;
  }

  openDisplayTypeModel(displayType, customListButton, channelConfig, index) {
        const displayTypeDialogRef = this.dialog.open(DisplayTypeDialogComponent, {
            panelClass: 'default-dialog',
            width: '874px',
            height: '572px',
            data: {
                displayType: displayType,
                customListButton: customListButton,
                channelConfig: channelConfig,
                index: index
            }
        });

        return displayTypeDialogRef;
  }

  isDisplayTypeDefaultOrCustom(valuesToConfirm: {} ): string {
    let isDefault = true;
    for (let valuesToConfirmKey in valuesToConfirm) {
      if (valuesToConfirm[valuesToConfirmKey] !== CHANNEL_DEFAULTS[valuesToConfirmKey]) {
        isDefault = false;
      }
    }

    if (isDefault) {
      return SELECTED_DISPLAY_TYPE_TEXT.default;
    } else {
      return SELECTED_DISPLAY_TYPE_TEXT.custom;
    }
  }

}
